/* Const,Let & Var will be here */
export const DEFAULT_GROUP_BY = 'DEFAULT_GROUP_BY';
export const TIMECARD_GROUP_BY = 'TIMECARD_GROUP_BY';
/* Const,Let & Var will be here */

export function onDefaultGroupBy(groupBy) {
    return {
        type: DEFAULT_GROUP_BY,
        defaultGroupBy: groupBy
    };
}

export function groupByInTimecardPage(groupBy) {
    return {
        type: TIMECARD_GROUP_BY,
        timeCardGroupBy: groupBy
    };
}